import React from "react";
import styles from './Button.module.css';

function Button({ children, type = "button", variant, onClick }) {
  return (
    <button type={type} className={`${styles.button} ${styles[variant]}`} onClick={onClick}>
      {children}
    </button>
  );
}

export default Button;
